const videoBlock = $('.image-video-block--with-video');

$(videoBlock)
  .find('.btn')
  .click((e) => {
    e.preventDefault();
    $(videoBlock).addClass('show-video');
    $(videoBlock).find('iframe').src = $(videoBlock).find('iframe').src + '?autoplay=1';
  });
